import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import withTranslations from '../../utils/HighOrderComponent';
import { formatDate, getUserNameAndSurname } from '../../utils';
import { signetStates, signetStatuses } from '../../constants/globals';

class SignetRow extends Component {
  render() {
    const { index, signet, enums, isUserProcessor, isUserAuthorizedPerson } =
        this.props || {},
      { uniqueSerialNumber, plannedStart, statusChangedDate, id, decision } =
        signet || {},
      { requestForSignetApproval } = decision || {},
      { kjsMunicipality, client, referenceNumber } =
        requestForSignetApproval || {},
      { kjs } = kjsMunicipality || {},
      { SignetStatus, SignetState } = enums || {};
    const signetStatus = SignetStatus[signet.signetStatus];
    const signetState = SignetState[signet.signetState];
    let tdStatusStyle = '';
    let tdStateStyle = '';
    if (isUserProcessor || isUserAuthorizedPerson) {
      tdStateStyle =
        (signetState?.value === signetStates.OUT_OF_USE?.text &&
          signetStates.OUT_OF_USE?.color) ||
        (signetState?.value === signetStates.READY_TO_USE?.text &&
          signetStates.READY_TO_USE?.color) ||
        '';
      if (isUserAuthorizedPerson) {
        tdStatusStyle =
          (signet?.signetStatus === signetStatuses.COMPLEMENT_REQUIRED?.name &&
            signetStatuses.COMPLEMENT_REQUIRED?.color) ||
          (signet?.signetStatus === signetStatuses.FINISHED?.name &&
            signetStatuses.FINISHED?.color) ||
          '';
      }
      if (isUserProcessor) {
        tdStatusStyle =
          (signet?.signetStatus === signetStatuses.COMPLEMENTED?.name &&
            signetStatuses.COMPLEMENTED?.color) ||
          (signet?.signetStatus === signetStatuses.APPROVED?.name &&
            signetStatuses.APPROVED?.color) ||
          (signet?.signetStatus === signetStatuses.DELIVERED?.name &&
            signetStatuses.DELIVERED?.color) ||
          '';
      }
    }
    const authorizedPerson = getUserNameAndSurname(client);

    const row = (
      <tr className="text-center">
        <td>{index}</td>
        <td>{referenceNumber}</td>
        <td>{uniqueSerialNumber}</td>
        <td>{kjs?.name}</td>
        <td>{plannedStart && formatDate(plannedStart)}</td>
        <td>{statusChangedDate && formatDate(statusChangedDate)}</td>
        <td>{authorizedPerson}</td>
        <td className={tdStateStyle}>{signetState?.text}</td>
        <td className={tdStatusStyle}>{signetStatus?.text}</td>
        <td>
          <Link to={`/signetProcessingView/${id}`}>
            <i className="fas fa-edit fa-2x" />
          </Link>
        </td>
      </tr>
    );

    return <Fragment>{row}</Fragment>;
  }
}

export default withTranslations(SignetRow, 'SignetRow');
